import { get, post, put, patch } from "../Config"

export function SearchLanguageTranslation({ params = {}, lang }) {
  return get({ url: `/v1/admin/language-translation`, params, lang })
}
export function GetLanguageTranslationById({ id, lang }) {
  return get({ url: `/v1/admin/language-translation/${id}`, lang })
}
export function CreateLanguageTranslation({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/language-translation`, params, data, lang })
}
export function UpdateLanguageTranslation({ params = {}, data = {} , id, lang }) {
  return put({ url: `/v1/admin/language-translation/${id}`, params, data, lang })
}
export function PatchLanguageTranslation({ params = {}, data = {} , id, lang }) {
  return patch({ url: `/v1/admin/language-translation/${id}`, params, data, lang })
}
export function DeleteLanguageTranslation({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/language-translation/mutiDelete`, params, data, lang })
}
export function GetLanguageOption(){
  return get({ url: `/v1/admin/language-translation/lang-option` })
}
